var _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWitness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 23.45,
    viewBox: "0 0 20.5 23.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-witness"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.7,11.2h-.2a5.35,5.35,0,1,1,.3,0ZM7.8,5.8a3.78,3.78,0,0,0,3.7,3.8h.3a3.8,3.8,0,1,0-4-3.8Z",
    transform: "translate(-1.95 -0.4)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5,22.8a5.32,5.32,0,0,1-1.9-8.1,8.48,8.48,0,0,1,10-2.4,1,1,0,0,1,.5,1.1.61.61,0,0,1-.9.5,7.27,7.27,0,0,0-8.5,2,3.36,3.36,0,0,0-.7,3,3.26,3.26,0,0,0,2,2.3,6.54,6.54,0,0,0,4.6.4.89.89,0,0,1,.4,1.7A7.88,7.88,0,0,1,5,22.8Z",
    transform: "translate(-1.95 -0.4)",
    fill: "{props.color}"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.4,17.7a5.91,5.91,0,0,1,5.9-5.9,5.9,5.9,0,0,1,0,11.8A5.91,5.91,0,0,1,10.4,17.7Zm.8,0a5.1,5.1,0,1,0,5.1-5.1A5.12,5.12,0,0,0,11.2,17.7Z",
    transform: "translate(-1.95 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.48,19.42a3.29,3.29,0,0,1,1.91.68,5.25,5.25,0,0,1,.62.53.51.51,0,0,1-.2.86.55.55,0,0,1-.41-.06A4.82,4.82,0,0,0,17.12,21a3.44,3.44,0,0,0-2.14.28l-.45.22a.49.49,0,0,1-.63-.14.5.5,0,0,1,0-.66A3.94,3.94,0,0,1,16,19.47,3.91,3.91,0,0,1,16.48,19.42Zm0,.37-.37,0a3.58,3.58,0,0,0-1.89,1.06.13.13,0,0,0,0,.19c.05.07.11.05.17,0l.47-.22a3.87,3.87,0,0,1,2.72-.21,5,5,0,0,1,1,.44c.06,0,.13,0,.16,0a.54.54,0,0,0,0-.18s0,0,0,0c-.24-.19-.46-.4-.7-.57A2.89,2.89,0,0,0,16.48,19.79Z",
    transform: "translate(-1.95 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.94,17.33a1.78,1.78,0,0,1-.52,1.29,1.58,1.58,0,0,1-2.35,0A1.87,1.87,0,0,1,17.16,16a1.62,1.62,0,0,1,2.59.5A1.91,1.91,0,0,1,19.94,17.33Zm-3,0a1.5,1.5,0,0,0,.13.62,1.25,1.25,0,0,0,2.15.31,1.53,1.53,0,0,0,0-1.83,1.22,1.22,0,0,0-1.78-.23A1.44,1.44,0,0,0,17,17.33Z",
    transform: "translate(-1.95 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78,15.54a1.58,1.58,0,0,1,1.24.68,1.85,1.85,0,0,1-.16,2.41,1.57,1.57,0,0,1-2.24.05,1.86,1.86,0,0,1,.28-2.91A1.62,1.62,0,0,1,14.78,15.54ZM16,17.45a1.59,1.59,0,0,0-.25-1,1.23,1.23,0,0,0-1.87-.25A1.5,1.5,0,0,0,14,18.49a1.2,1.2,0,0,0,1.45,0A1.37,1.37,0,0,0,16,17.45Z",
    transform: "translate(-1.95 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.64,14.4a.5.5,0,0,1,.14-.08,1.69,1.69,0,0,1,1.64.23,1.05,1.05,0,0,1,.23.24.22.22,0,0,1,0,.11s0,.08,0,.1h-.12a.18.18,0,0,1-.08-.07c-.12-.1-.23-.21-.36-.3a1.75,1.75,0,0,0-1.36-.22l-.1,0Z",
    transform: "translate(-1.95 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.13,14.47a2.17,2.17,0,0,0-.25,0,1.71,1.71,0,0,0-1.52.54.53.53,0,0,1-.14.12c-.08,0-.14,0-.12-.09a.36.36,0,0,1,.07-.17,1.45,1.45,0,0,1,.56-.42A1.74,1.74,0,0,1,19,14.36l.14.08Z",
    transform: "translate(-1.95 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.49,19.52A2.89,2.89,0,0,1,18,20c.24.17.47.38.7.57,0,0,0,0,0,0a.54.54,0,0,1,0,.18c0,.06-.1.05-.16,0a5,5,0,0,0-1-.44,3.87,3.87,0,0,0-2.72.21l-.47.22c-.06,0-.12.05-.17,0a.13.13,0,0,1,0-.19,3.62,3.62,0,0,1,1.89-1.06Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,17.33a1.44,1.44,0,0,1,.52-1.13,1.22,1.22,0,0,1,1.78.23,1.53,1.53,0,0,1,0,1.83A1.25,1.25,0,0,1,17.1,18,1.5,1.5,0,0,1,17,17.33Zm1.51.15a.5.5,0,0,0-.41-.55.46.46,0,0,0-.46.44.62.62,0,0,0,0,.23.41.41,0,0,0,.67.25A.54.54,0,0,0,18.48,17.48Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,17.45a1.37,1.37,0,0,1-.59,1.07,1.2,1.2,0,0,1-1.45,0,1.5,1.5,0,0,1-.08-2.25,1.23,1.23,0,0,1,1.87.25A1.59,1.59,0,0,1,16,17.45Zm-.69,0a.44.44,0,1,0-.87,0v.06a.51.51,0,0,0,.3.43.36.36,0,0,0,.39-.08A.52.52,0,0,0,15.32,17.47Z",
    transform: "translate(-1.95 -0.4)",
    fill: "#fff",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.95 -0.4)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.95 -0.4)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53,23.3",
    transform: "translate(-1.95 -0.4)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWitness);
export default __webpack_public_path__ + "static/media/user-witness.480f532c1903e0d6cf4e79eb6900f68d.svg";
export { ForwardRef as ReactComponent };